const getIsValueEmpty = (value: string) => !value || value.trim() === '';

export default getIsValueEmpty;
